import { authToken } from 'src/app/auth/cookies';
import { useEffect, useState } from 'react';

const useCheckSession = (): boolean => {
  const [session, setSession] = useState(false);

  useEffect(() => setSession(Boolean(authToken())), []);

  return session;
};

export default useCheckSession;
